// extracted by mini-css-extract-plugin
module.exports = {"sticky-footer":"_1NzZyFnm8Koyel8WKMINbS"};